// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"f17e5deb","958":"f17e5deb"}[chunkId] + ".chunk.css";
};